import { TemplateColors } from '@/constants/enum';

export const templateColors = {
  default: [
    {
      background_color: 'transparent',
      border_color: 'transparent',
      icon_color: '#000000',
      key: TemplateColors.CLEAR,
      text_color: '#000000',
    },
    {
      background_color: '#ffffff',
      border_color: '#ffffff',
      icon_color: '#000000',
      key: TemplateColors.WHITE,
      text_color: '#000000',
    },
    {
      background_color: '#F3F4F6',
      border_color: '#D1D5DB',
      icon_color: '#4B5563',
      key: TemplateColors.SILVER,
      text_color: '#000000',
    },
    {
      background_color: '#F1F5F9',
      border_color: '#CEDDE9',
      icon_color: '#3D698C',
      key: TemplateColors.SLATE,
      text_color: '#000000',
    },
  ],
  rest: [
    {
      background_color: '#EEF2FF',
      border_color: '#C7D2FE',
      icon_color: '#6366F1',
      key: TemplateColors.INDIGO,
      text_color: '#000000',
    },
    {
      background_color: '#F5F3FF',
      border_color: '#DDD6FE',
      icon_color: '#8B5CF6',
      key: TemplateColors.PURPLE,
      text_color: '#000000',
    },
    {
      background_color: '#F0F9FF',
      border_color: '#BAE6FD',
      icon_color: '#0EA5E9',
      key: TemplateColors.SKY,
      text_color: '#000000',
    },
    {
      background_color: '#ECFEFF',
      border_color: '#A5F3FC',
      icon_color: '#06B6D4',
      key: TemplateColors.CYAN,
      text_color: '#000000',
    },
    {
      background_color: '#F0FDFA',
      border_color: '#99F6E4',
      icon_color: '#14B8A6',
      key: TemplateColors.TEAL,
      text_color: '#000000',
    },
    {
      background_color: '#F0FDF4',
      border_color: '#BBF7D0',
      icon_color: '#16A34A',
      key: TemplateColors.MINT,
      text_color: '#000000',
    },
    {
      background_color: '#F7FEE7',
      border_color: '#BEF264',
      icon_color: '#65A30D',
      key: TemplateColors.LIME,
      text_color: '#000000',
    },
    {
      background_color: '#FEFCE8',
      border_color: '#FDE047',
      icon_color: '#CA8A04',
      key: TemplateColors.YELLOW,
      text_color: '#000000',
    },
    {
      background_color: '#FFF7ED',
      border_color: '#FED7AA',
      icon_color: '#F97316',
      key: TemplateColors.ORANGE,
      text_color: '#000000',
    },
    {
      background_color: '#FBF3EE',
      border_color: '#E2D0BB',
      icon_color: '#A67A4D',
      key: TemplateColors.LATTE,
      text_color: '#000000',
    },
    {
      background_color: '#FFF5F5',
      border_color: '#FFC9C9',
      icon_color: '#FA5252',
      key: TemplateColors.RED,
      text_color: '#000000',
    },
    {
      background_color: '#FDF2F8',
      border_color: '#FBCFE8',
      icon_color: '#EC4899',
      key: TemplateColors.PINK,
      text_color: '#000000',
    },
  ],
};
